export enum OrderSciEventAction {
  // EventOptionPaymentStepName
  SelectPaymentType = 'select_payment_type',
  Requisites = 'requisites',
  CustomerConfirmDetails = 'customer_confirm_details',
  CustomerConfirmTransfer = 'customer_confirm_transfer',
  TraderConfirm = 'trader_confirm',
  // EventOptionClickAction
  TelegramHelp = 'telegram_help',
  TelegramUploadReceipt = 'telegram_upload_receipt',
  OrderCancel = 'order_cancel',
  ConfirmCustomerDetails = 'confirm_customer_details',
  ConfirmTransfer = 'confirm_transfer',
  BackToShop = 'back_to_shop',
  SaveQr = 'save_qr',
  DeeplinkOpen = 'deeplink_open',
  SelectAlternativeAmount = 'select_alternative_amount',
  ResetTradeMethod = 'reset_trade_method',
  ShowAlternativesModal = 'show_alternatives_modal',
}
